import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    payableTo: {
        payableTo: { value: "", isValid: true },
        name: { value: "", isValid: true },
        addressLine1: { value: "", isValid: true },
        addressLine2: { value: "", isValid: true },
        city: { value: "", isValid: true },
        state: { value: "", isValid: true },
        zipCode: { value: "", isValid: true },
        isAddressVerified: false,
        smartyStreetMatches: {
            NoMatch: false,
            PartialMatch: false,
            SecInfoNotMatch: false,
            ExactMatch: false,
        },
        ss_msg_cls: '',
        ss_msg: '',
    },
    claimDocumentsData: [],
    uploadedDocuments: [],
    cancelNavigate: false
}

const claimIntakeSlice = createSlice({
    name: 'claimIntake',
    initialState,
    reducers: {
        payableToData: (state, action) => {
            const claimUserData = action.payload.claimUserData
            if (action.payload.payableToInfo.payableTo.value == "Patient/Guardian") {
                state.payableTo.payableTo = action.payload.payableToInfo.payableTo
                state.payableTo.name.value = claimUserData.hasGuardian ? (claimUserData.guardianDetails.firstName + " " + claimUserData.guardianDetails.lastName) : claimUserData.patientDetails.fullName
                state.payableTo.addressLine1.value = (claimUserData.hasGuardian && claimUserData.guardianDetails.isAddressSameAsPatient != true) ? claimUserData.guardianDetails.addressLine1 : claimUserData.patientDetails.addressLine1
                state.payableTo.addressLine2.value = ((claimUserData.hasGuardian && claimUserData.guardianDetails.isAddressSameAsPatient != true) ? claimUserData.guardianDetails.addressLine2 : claimUserData.patientDetails.addressLine2) || ""
                state.payableTo.city.value = (claimUserData.hasGuardian && claimUserData.guardianDetails.isAddressSameAsPatient != true)? claimUserData.guardianDetails.city : claimUserData.patientDetails.city
                state.payableTo.state.value = (claimUserData.hasGuardian && claimUserData.guardianDetails.isAddressSameAsPatient != true) ? claimUserData.guardianDetails.state : claimUserData.patientDetails.state
                state.payableTo.zipCode.value = (claimUserData.hasGuardian && claimUserData.guardianDetails.isAddressSameAsPatient != true) ? claimUserData.guardianDetails.zipCode : claimUserData.patientDetails.zipCode
            } else {
                state.payableTo = action.payload.payableToInfo
            }
        },
        claimUploadDocumentsData: (state, action) => {
            state.claimDocumentsData = action.payload.tempArr
            state.uploadedDocuments = action.payload.files
        },
        resetClaimIntakeData: (state, action) => {
            state.payableTo = {
                payableTo: { value: "", isValid: true },
                name: { value: "", isValid: true },
                addressLine1: { value: "", isValid: true },
                addressLine2: { value: "", isValid: true },
                city: { value: "", isValid: true },
                state: { value: "", isValid: true },
                zipCode: { value: "", isValid: true },
                isAddressVerified: false,
                smartyStreetMatches: {
                    NoMatch: false,
                    PartialMatch: false,
                    SecInfoNotMatch: false,
                    ExactMatch: false,
                },
                ss_msg_cls: '',
                ss_msg: '',
            }
            state.claimDocumentsData = []
            state.uploadedDocuments = []
        },
        cancelNavigate: (state, action) => {
            state.cancelNavigate = action.payload

        }
    }
}
)

export const { claimUploadDocumentsData, payableToData, resetClaimIntakeData, cancelNavigate } = claimIntakeSlice.actions

export default claimIntakeSlice.reducer